<template>
  <v-tooltip :bottom="bottom" :right="right" :color="color" max-width="400" close-delay="200">
    <template v-slot:activator="{ on, attrs }">
      <v-icon :class="iconClass" v-bind="attrs" v-on="on">icon-label-questionmark</v-icon>
    </template>

    <slot />
  </v-tooltip>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class InfoTooltip extends Vue {
  @Prop({ default: "white" }) color: string;
  @Prop({ default: true }) bottom: boolean;
  @Prop({ default: undefined }) right: boolean;
  @Prop({ default: "pl-1" }) iconClass: string;
}
</script>
